import React from 'react'
import PropTypes from 'prop-types'
import { BrandsImage, BrandsMain, BrandTitle } from './index.style'
import Container from '@components/Container'
import Spacer from '@components/Spacer'
import { GatsbyImage } from 'gatsby-plugin-image'
import BrandsGrid from '../BrandsGrid'
import { Heading2Serif } from '@components/TextStyles'
import useGetColor from '../useGetColor'

const Brands = ({ data, backgroundColor: bgColor, textColor: tColor }) => {
  const {items, title, background, titleStyle, gridColumns} = data;
  const [backgroundColor, textColor] = useGetColor(background, bgColor, tColor)
  const carouselItems = items.map(brand => (
    <BrandsImage>
      <GatsbyImage image={brand.gatsbyImageData} alt={brand.description} height="170" width="170" />
    </BrandsImage>
  ))

  return (
    <BrandsMain color={textColor} background={backgroundColor}>
      <Container>
        <Spacer size={[70, 80]} />
        <>
          {(titleStyle === "Signifier Light") ?
            <Heading2Serif maxWidth={11}>{title}</Heading2Serif>
            :
            <BrandTitle>{title}</BrandTitle>
          }
        </>

        <Spacer size={[20, 80]} />

        <BrandsGrid items={carouselItems} itemsPerRow={6} gridColumns={gridColumns} />

        <Spacer size={[50, 110]} />
      </Container>
    </BrandsMain>
  )
}

Brands.propTypes = {
  items: PropTypes.array
}

export default Brands
